export const MAP_MONTH_NAME = {
  1: { name: "Janeiro", short: "JAN", refNumber: 1 },
  2: { name: "Fevereiro", short: "FEV", refNumber: 2 },
  3: { name: "Março", short: "MAR", refNumber: 3 },
  4: { name: "Abril", short: "ABR", refNumber: 4 },
  5: { name: "Maio", short: "MAI", refNumber: 5 },
  6: { name: "Junho", short: "JUN", refNumber: 6 },
  7: { name: "Julho", short: "JUL", refNumber: 7 },
  8: { name: "Agosto", short: "AGO", refNumber: 8 },
  9: { name: "Setembro", short: "SET", refNumber: 9 },
  10: { name: "Outubro", short: "OUT", refNumber: 10 },
  11: { name: "Novembro", short: "NOV", refNumber: 11 },
  12: { name: "Dezembro", short: "DEZ", refNumber: 12 }
};

export const MAP_MONTH_NUMBER = {
  janeiro: 1,
  fevereiro: 2,
  marco: 3,
  abril: 4,
  maio: 5,
  junho: 6,
  julho: 7,
  agosto: 8,
  setembro: 9,
  outubro: 10,
  novembro: 11,
  dezembro: 12
};

export const PERIODICITY_NAME_MAP = {
  monthly: "Mensal",
  bimonthly: "Bimestral",
  quarterly: "Trimestral",
  half: "Semestral",
  yearly: "Anual"
};
